import useUser from './useUser';

export default function useUserFullName(userId: string): void | string {
  const user = useUser(userId);

  return user ? `${user.given_name} ${user.family_name}` : void 0;
}
